module.exports = __webpack_public_path__ + "img/detail_close_icon.9a5b70aa.svg";